import type { SVGProps } from 'react';
const DawnFlagAF = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-AF_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-AF_svg__a)">
      <path fill="#1AB11F" d="M10.477 0h11.524v16H10.477z" />
      <path fill="#262626" fillRule="evenodd" d="M0 16h7.333V0H0z" clipRule="evenodd" />
      <path
        fill="#DC0D18"
        fillRule="evenodd"
        d="M7.333 16h7.333V0H7.333z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M9.571 7.467a.667.667 0 1 0-1.333 0zm.04 2.42a.667.667 0 0 0 .678-1.148zm2.152-1.18a.667.667 0 1 0 .728 1.117zm1.998-1.24a.667.667 0 1 0-1.333 0zm-5.523 0c0 1.03.55 1.934 1.372 2.42l.679-1.148a1.47 1.47 0 0 1-.718-1.272zm4.253 2.357a2.81 2.81 0 0 0 1.27-2.357h-1.333c0 .524-.267.98-.665 1.24z"
        opacity={0.75}
      />
      <path
        fill="#fff"
        fillOpacity={0.5}
        fillRule="evenodd"
        d="M11 8.533c.578 0 1.047-.716 1.047-1.6 0-.883-.469-1.6-1.047-1.6-.579 0-1.048.717-1.048 1.6s.47 1.6 1.048 1.6"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagAF;
